import { render } from "./CoachesDeatail.vue?vue&type=template&id=c0859468"
import script from "./CoachesDeatail.vue?vue&type=script&lang=js"
export * from "./CoachesDeatail.vue?vue&type=script&lang=js"

import exportComponent from "/home/hiba/project03-vue.js-find-a-coach/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__